export const COMMON_BORDER_RADIUS = 5
export const COMMON_LINE_HEIGHT = 16
export const COMMON_PADDING_X = 5

export const COMMON_FONT = '12px Inter'
export const COMMON_TEXT_COLOR = '#1f1f1f'
